import styled from '@emotion/styled/macro';

export const Container = styled.div`
  padding: 30px;
  background-color: #f5f6f8;
  min-height: 100vh;
`;

export const ContentWrapper = styled.div`
  background-color: white;
  border-radius: 8px;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.05);
  padding: 30px;
  margin-top: 20px;
`;

export const Header = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 30px;
`;

export const HeaderTitle = styled.div`
  display: flex;
  align-items: center;
  gap: 10px;
`;

export const BackButton = styled.button`
  background: none;
  border: none;
  cursor: pointer;
  display: flex;
  align-items: center;
  color: #444;

  &:hover {
    color: #000;
  }
`;

export const Title = styled.h1`
  font-size: 24px;
  color: #444;
  margin-bottom: 0;
`;

export const Button = styled.button`
  background-color: #4285f4;
  color: white;
  border: none;
  border-radius: 4px;
  padding: 8px 16px;
  font-weight: 500;
  cursor: pointer;
  min-width: 100px;

  &:hover {
    background-color: #3b78e7;
  }
`;

export const FormContainer = styled.div`
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 30px;
`;

export const FormSection = styled.div`
  display: flex;
  flex-direction: column;
  gap: 15px;
`;

export const Input = styled.input`
  padding: 10px;
  border: 1px solid #ddd;
  border-radius: 4px;
  font-size: 14px;

  &:focus {
    outline: none;
    border-color: #4285f4;
  }
`;

export const SelectContainer = styled.div`
  position: relative;
`;

export const Select = styled.select`
  width: 100%;
  padding: 10px;
  border: 1px solid #ddd;
  border-radius: 4px;
  font-size: 14px;
  appearance: none;
  background-color: white;

  &:focus {
    outline: none;
    border-color: #4285f4;
  }
`;

export const SelectArrow = styled.div`
  position: absolute;
  right: 12px;
  top: 50%;
  transform: translateY(-50%);
  pointer-events: none;
`;

export const Textarea = styled.textarea`
  padding: 10px;
  border: 1px solid #ddd;
  border-radius: 4px;
  font-size: 14px;
  min-height: 100px;
  resize: vertical;

  &:focus {
    outline: none;
    border-color: #4285f4;
  }
`;

export const QuestionsContainer = styled.div`
  display: flex;
  flex-direction: column;
  gap: 10px;
`;

export const QuestionItem = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-evenly;
  gap: 10px;
`;

export const Checkbox = styled.div`
  width: 20px;
  height: 20px;
  border: 1px solid #ddd;
  border-radius: 4px;
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  background-color: ${(props) => (props.isChecked ? '#4285f4' : 'transparent')};
  border-color: ${(props) => (props.isChecked ? '#4285f4' : '#ddd')};
  color: white;
  flex-shrink: 0;
`;

export const AddQuestionButton = styled.button`
  width: 30px;
  height: 30px;
  border-radius: 50%;
  background-color: #4285f4;
  color: white;
  border: none;
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  align-self: center;
  margin-top: 10px;

  &:hover {
    background-color: #3b78e7;
  }
`;

export const ToggleContainer = styled.div`
  display: flex;
  align-items: center;
  gap: 10px;
  margin-bottom: 20px;
  justify-content: flex-end;
`;

export const ToggleLabel = styled.div`
  font-size: 14px;
  color: #444;
`;
